import { DocumentView } from "@/components/documents/DocumentView";
import { useMemo } from "react";
import { useApolloClient } from "@apollo/client/react";
import { MatchProjectDocumentContentDocument } from "@/graphql/generated/operations";
import { base64ToBlob } from "@/lib/use-open-document";
import { createDocumentResource } from "@/lib/document-resource";
import type { FileEntry } from "./match-design-types";

export function MatchDocumentPreview({ matchId, file, onRemove }: { matchId: string; file: FileEntry; onRemove?: () => void }) {
  const client = useApolloClient();
  const fileId = file.backdropFileId!;
  const resource = useMemo(() => createDocumentResource({ name: file.name, mimeType: file.type, load: async () => {
    const { data } = await client.query({ query: MatchProjectDocumentContentDocument,
      variables: { matchId, backdropFileId: fileId }, fetchPolicy: "no-cache" });
    const content = data?.matchProjectDocumentContent;
    if (!content?.content) throw new Error("Missing document content");
    return base64ToBlob(content.content, content.mimeType ?? file.type);
  } }), [client, matchId, fileId, file.name, file.type]);
  return <DocumentView variant="tile" idPrefix={`match-doc-preview-${fileId}`} file={resource} name={file.name} sizeBytes={file.size} onRemove={onRemove} />;
}
